import React from "react";
import { connect } from "react-redux";
import UserCollection from "./index";
import { addUser, updateUser, checkEmail } from "../../../modules/user/actions";
// import addBlogPost from '../../../modules/blog/addBlogPost';

class UserCollectionContainer extends React.Component {
  render() {
    return (
      <UserCollection
        {...this.props}
        addUser={(email, rolle, name) => this.props.addUser(email, rolle, name)}
        checkEmail={this.props.checkEmail(
          this.props.email,
          this.props.userExist
        )}
        updateUser={this.props.updateUser}
        language={this.props.language}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.preference.language,
    email: state.user.email,
    userExist: state.user.userExist,
    password: state.user.password,
    rolle: state.user.role_add,
    name: state.user.name
  };
}

const mapActionToProps = {
  checkEmail,
  addUser,
  updateUser
};

export default connect(
  mapStateToProps,
  mapActionToProps
)(UserCollectionContainer);



// WEBPACK FOOTER //
// ./src/pages/Admin/UsersCollection/container.js